<main class="main-wrapper">
  @if (videos?.length > 0) {
    <header class="video-header">
      <h1 class="video-header__title">{{ titulo }}</h1>
    </header>
    @if (videoPlaying?.securityUrl) {
      <div class="content">
        <div class="content__video-frame">
          @if (videoPlaying.securityUrl) {
            <iframe
              #iframe
              [src]="videoPlaying.securityUrl"
              width="100%"
              height="100%"
              frameborder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowfullscreen
            ></iframe>
          }
        </div>
        <div class="video-listing">
          @for (video of videos; track video) {
            <div class="video-listing__item">
              <a
                (click)="forceUpdateVideoPlaying(video)"
                [attr.data-tracking-id]="'serie-video-assistir-' + video.titulo"
                class="video-listing__item__name"
                [ngClass]="
                  videoPlaying.id == video.id
                    ? 'video-listing__item__name--active'
                    : ''
                "
              >
                {{ video.titulo }}
              </a>
            </div>
          }
        </div>
      </div>
    }
  } @else {
    <span class="without-items">{{ 'messages.no_videos' | translate }}</span>
  }
</main>
